import { ICueRecipient } from 'app/models/Tasks/Tasks';

export const getCueNoteFilterOptions = (data: ICueRecipient[]) => {
  const CuedTochildren: any[] = [];
  const RepliedTochildren: any[] = [];
  data?.forEach(cueRecipient => {
    const recipientTreeData = {
      name: cueRecipient?.firstName + ' ' + cueRecipient?.lastName,
      value: cueRecipient?.employeeId?.toString(),
    };
    CuedTochildren.push(recipientTreeData);
    RepliedTochildren.push(recipientTreeData);
  });
  const treeData = [
    {
      children: CuedTochildren,
      name: 'Cued To',
      value: 1,
    },
    {
      children: RepliedTochildren,
      name: 'Replied To',
      value: 2,
    },
  ];
  return treeData;
};
